import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { quixoticCollectionLink } from '../../utils/string'

const useStyles = makeStyles((theme) => ({
  notificationSection: {
    color: 'white',
    padding: '1rem',
    borderRadius: '.8rem',
    background: 'rgba(0, 0, 0, 0.4)',
    width: '100%',
    textAlign: 'center',

    '& a': {
      color: 'white',
      padding: '0.4rem',
    },

    '& p': {
      fontSize: '1rem',
    },

    '&.success': {
      background: 'rgba(95, 221, 183, 0.4)',
    },
    '&.error': {
      background: 'rgba(221, 95, 133, 0.4)',
    },
  },
  mint: {},

  mintButton: {
    padding: '1rem 4rem',
  },
  mintButtonDisabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
  },
  mintButtonLabel: {
    color: 'white',
  },
}))

function MintOver(): JSX.Element {
  const classes = useStyles()

  return (
    <>
      <div className={`${classes.notificationSection} success`}>
        <Typography variant="body2">Oops, All NFTs have been minted</Typography>
        <Typography variant="subtitle2">
          <a href={quixoticCollectionLink()} target="_blank" rel="noreferrer">
            You can buy one Quixotic ⇗
          </a>
        </Typography>
      </div>
    </>
  )
}

export default MintOver
